import { Component } from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink,
} from 'reactstrap';
import PropTypes from 'prop-types';
import DashBoardSummaryComponent from '../dashboard-summary-component/DashBoardSummaryComponent.js';
import DashBoardRequestUpComponent from '../dashboard-request-up-component/DashBoardRequestUpComponent';
import DashBoardStatisticsComponent from '../dashboard-statistics-component/DashBoardStatisticsComponent.js';

const tabsDefinition = {
  summary: {
    id: 'summary',
    title: 'Su resumen de trabajo',
    componentName: DashBoardSummaryComponent,
  },
  statistics: {
    id: 'statistics',
    title: 'ESTADÍSTICAS',
    componentName: DashBoardStatisticsComponent,
  },
  request_upload: {
    id: 'request_upload',
    title: 'SUBIR SOLICITUDES',
    componentName: DashBoardRequestUpComponent,
  },
};

class DashBoardHeaderContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: tabsDefinition.summary.id,
    };
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const { activeTab } = this.state;

    return (
      <div className="mb-5">
        <Nav tabs className="tabs-light">
          {Object.keys(tabsDefinition).map((key) => {
            const tab = tabsDefinition[key];
            return (
              <NavItem key={`tab-nav-item-${key}`}>
                <NavLink
                  key={`tab-nav-${key}`}
                  className={activeTab === tab.id ? 'active' : ''}
                  onClick={() => this.toggleTab(tab.id)}
                >
                  {tab.title}
                </NavLink>
              </NavItem>
            );
          })}
        </Nav>
        <TabContent activeTab={activeTab}>
          {Object.keys(tabsDefinition).map((key) => {
            const tab = tabsDefinition[key];
            return (
              <TabPane tabId={tab.id} key={`tab-pane-${key}`}>
                {activeTab === tab.id
                  ? (
                    <tab.componentName
                      id={tab.id}
                      tab={tab.id}
                      key={`tab-list-${key}`}
                      showMore={this.props.showMore}
                      showSuccesMessage={this.props.showSuccesMessage}
                      showErrorMessage={this.props.showErrorMessage}
                    />
                  )
                  : <div key={`tab-loading-${key}`}>Cargando</div>}
              </TabPane>
            );
          })}
        </TabContent>
      </div>
    );
  }
}

DashBoardHeaderContainer.propTypes = {
  showErrorMessage: PropTypes.func,
  showMore: PropTypes.func,
  showSuccesMessage: PropTypes.func,
};

export default DashBoardHeaderContainer;
